package io.horion.cv.api.datasource.response

enum class PaymentStatus {
    PENDING, SUCCESS, FAILED
}